import { render, staticRenderFns } from "./ArtiklModalEdit.vue?vue&type=template&id=0cb34dcd"
import script from "./ArtiklModalEdit.vue?vue&type=script&lang=js"
export * from "./ArtiklModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports